import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import './AdministratePatientButton.scss';
import { UserContext, isInRole } from '../../../../contexts/UserContext';
import { LIBRETTOADMIN } from '../../../../utils/RoleConstants';

interface IAdministratePatientButton {
    canRefrainFromFreeDentalCare?: boolean;
    canReactivateFreeDentalCare?: boolean;
    canDelistPatient?: boolean;
    canUnregisterLkgCfPatient?: boolean;
}

export const AdministratePatientButton: React.FunctionComponent<IAdministratePatientButton> = ({ canRefrainFromFreeDentalCare, canReactivateFreeDentalCare, canDelistPatient, canUnregisterLkgCfPatient }) => {
    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles ? userInfo.roles : []);

    return (
        <>
            {
                canRefrainFromFreeDentalCare || canReactivateFreeDentalCare || canDelistPatient || canUnregisterLkgCfPatient ?
                    <div className="administrate-patient-button" >
                        <div className="btn-group">
                            <button type="button" id="administratePatientMenuButton" className="btn btn-sm btn-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                disabled={!(canRefrainFromFreeDentalCare || canReactivateFreeDentalCare || canDelistPatient || canUnregisterLkgCfPatient)}>
                                <FontAwesomeIcon tabIndex={-1} icon={faCog} size="lg" /> Administrera <FontAwesomeIcon tabIndex={-1} icon={faCaretDown} size="lg" />
                            </button>

                            <div className="dropdown-menu" aria-labelledby="administratePatientMenuButton">
                                {
                                    canRefrainFromFreeDentalCare ?
                                        <a className="dropdown-item" data-toggle="modal" data-target="#refrain-free-dental-care-modal" href="#">Avstår avgiftsfri tandvård</a>
                                        : null
                                }
                                {
                                    canReactivateFreeDentalCare ?
                                        <a className="dropdown-item" data-toggle="modal" data-target="#reactivate-free-dental-care-modal" href="#">Återgå till avgiftsfri tandvård</a>
                                        : null
                                }
                                {
                                    canDelistPatient ?
                                        <a className="dropdown-item" data-toggle="modal" data-target="#delist-patient-modal" href="#">Avlista patient</a>
                                        : null
                                }
                                {
                                    canUnregisterLkgCfPatient ?
                                        <a className="dropdown-item" data-toggle="modal" data-target="#unregister-lkg-cf-patient-modal" href="#">{hasRoleSystemAdmin ? "Avregistrera och kreditera LKG/CF-patient från systemet för käkortopedi" : "Avregistrera LKG/CF-patient från systemet för käkortopedi"}</a>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                    : null
            }
        </>
    )
}